import React from 'react'
import ReactDOM from 'react-dom'
import 'fomantic-ui-css/semantic.min.css'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'mobx-react'
import AuthenticationStore from './stores/AuthenticationStore'
import EventsStore from './stores/EventsStore'
import CalendarStore from './stores/CalendarStore'
import ClientsStore from './stores/ClientsStore'
import SyncedStore from './stores/SyncedStore'

/**
 * Initialize global stores
 */
// User Store
const authenticationStore = new AuthenticationStore(false)
authenticationStore.initialize()
ReactDOM.render(
  <Provider
    authenticationStore={authenticationStore}
    eventsStore={(new EventsStore())}
    calendarStore={(new CalendarStore())}
    clientsStore={(new ClientsStore())}
    syncedStore={(new SyncedStore())}
  >
    <App />
  </Provider>, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
